import React from "react";
import { Route, Routes } from "react-router-dom";
import ListVolunteerPage from "./ListVolunteerPage";

export default function MsfPage() {
  return (
    <Routes>
      <Route path="/volunteer" element={<ListVolunteerPage />} />
    </Routes>
  );
}
